<template>
    <div class="c-picked__item u-flex-set" :title="item[optionName]">
        <span class="c-picked__name"><span>{{item[optionName]}}</span></span>
        <div class="u-flex-set u-flex--align-items-center u-flex--push-left u-flex--no-shrink o-gutter-tiny">
            <div class="u-flex-set">
                <button class="c-button--reset c-picked__default" :disable="item.IsDefault" :class="{'is-default': item.IsDefault}" type="button" @click="setDefault()" v-model="item.IsDefault">
                    <span v-if="item.IsDefault"><svgicon name="check" width=".8em" height=".8em"></svgicon> {{ $t('preorder_fiche.target_list.default') }}</span>
                    <span v-if="!item.IsDefault">{{ $t('preorder_fiche.target_list.mark_as_default') }}</span>
                </button>
            </div>
            <div class="u-flex-set">
                <button class="c-button--reset c-button--icon-only u-inline-flex-set" type="button" @click="removeItem()" title="remove">
                    <svgicon name="close"></svgicon>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VCustomSelect from '@/components/form/CustomSelect'

    export default {
        props: ['item', 'option-name'],
        methods: {
            removeItem() {
                this.$emit('remove', this.item)
            },
            setDefault() {
                this.$emit('default-change', this.item);
                this.$set(this.item, 'IsDefault', true);
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-picked__item {
        padding: em($global-spacing-unit-tiny) em($global-spacing-unit-small);
        &:not(:last-child) {
            border-bottom: 1px solid palette(color-neutral, light);
        }
    }

    .c-picked__name {
        flex: 1;
        min-width: 0;
        span{
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .c-picked__default {
        @include rfs($font-size-small);
        border-radius: 5px;
        svg {
            fill: $color-success;
        }
        &.is-default {
            background-color: palette(color-neutral, light);
        }
        span {
            display: inline-block;
            padding: 0 em($global-spacing-unit-tiny);
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/form/targetList/TargetOption.vue